<!-- =========================================================================================
  File Name: locationSettingSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }}

           SETTINGS FOR :</h4> <vs-chip  color="primary" class="mr-10">
      <p >{{LocationName}}</p>
    </vs-chip>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
                <label>Maximum Number Of Students</label><br><br>

        <ul class="centerx flex">
          <li>
            <vs-radio v-model="maxNoOfStudents" vs-value="10">10</vs-radio>
          </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfStudents" vs-value="50">50</vs-radio>
          </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfStudents" vs-value="100">100</vs-radio>
          </li>
   <li class="ml-2">
            <vs-radio v-model="maxNoOfStudents" vs-value="1000">1000</vs-radio>
          </li>
   <li class="ml-2">
            <vs-radio v-model="maxNoOfStudents" vs-value="5000">5000</vs-radio>
          </li>

        </ul><br>
          <vs-row vs-w="12">
          <vs-col  vs-lg="7" vs-sm="7" vs-xs="7">
            <label>Max Daily Logins Feature</label>
          </vs-col>
           <vs-col  vs-lg="3" vs-sm="3" vs-xs="3">
          </vs-col>
          <vs-col vs-lg="2" vs-sm="2" vs-xs="5" vs-type="flex"><vs-switch @click="setMaxDailyLogins()" v-model="dataMaxDailyLoginFeature"></vs-switch></vs-col>
        </vs-row><br>
        <!-- MAX LOGIN ATTEMPT -->
        <div v-if="dataMaxDailyLoginFeature">
        <label>Number of Max Daily Logins</label>
          <span>  &nbsp;
            <vs-button size="small" v-if="dataMaxDailyLogins !=0" v-html="dataMaxDailyLogins"></vs-button>
            <vs-button size="small" v-else >N/A</vs-button>
          </span>
        <vs-slider :max="10" :min="1" v-model="dataMaxDailyLogins" /></div>
        <!-- MAX LOGIN ATTEMPT -->
       <br>
        <label>User Time Out</label> <span>
        &nbsp;
        <vs-button size="small" v-if="dataUserTimeOut !=0" v-html="dataUserTimeOut"></vs-button>
        <vs-button size="small" v-else >N/A</vs-button>
      </span>

        <vs-slider :max="60" :min="10" v-model="dataUserTimeOut" />

      </div>

    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {GET_LOCATION_SETTING_DETAILS, UPDATE_LOCATION_SETTINGS} from "@/graphql";

export default {
  props: {
    isLocationSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {

      dataId: null,
      LocationName: null,
      dataMaxDailyLogins: '',
      dataUserTimeOut:0,
      maxNoOfStudents: '',
      dataMaxDailyLoginFeature:false,

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isLocationSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id,name} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.LocationName = name.toUpperCase()
        this.initValues()
        this.getLocationSettingData(this.dataId)

      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isLocationSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataMaxDailyLogins = ''
      this.dataUserTimeOut = ''
      this.maxNoOfStudents = ''
      this.dataMaxDailyLoginFeature = ''

    },
    getLocationSettingData(id) {
      console.log(id)
      this.$apollo
        .mutate({
          mutation: GET_LOCATION_SETTING_DETAILS,
          variables: {
            id:  id
          },
        })
        .then(response => {
          if(response.data.getLocationSettingData !=null){
          if(response.data.getLocationSettingData.status=='SUCCESS'){
            this.maxNoOfStudents = response.data.getLocationSettingData.max_no_of_students
            this.dataMaxDailyLogins = response.data.getLocationSettingData.max_daily_logins

            if(response.data.getLocationSettingData.enable_max_login_feature ==1){
              this.dataMaxDailyLoginFeature = true
            }
            else{
              this.dataMaxDailyLoginFeature = false
              this.dataMaxDailyLogins=0

            }
            if(response.data.getLocationSettingData.user_time_out ==0){
              this.dataUserTimeOut = 0
            }
            else {
              this.dataUserTimeOut = response.data.getLocationSettingData.user_time_out

            }

          }
          }
          else {
            this.maxNoOfStudents = 0
            this.dataMaxDailyLogins = 0
            this.dataUserTimeOut = 0
            this.dataMaxDailyLoginFeature = 1

          }

        })

    },
    submitData() {
        this.$apollo
          .mutate({
            mutation: UPDATE_LOCATION_SETTINGS,
            variables: {
              id: this.dataId,
              max_no_of_students: this.maxNoOfStudents,
              max_logins: this.dataMaxDailyLogins,
              time_out: this.dataUserTimeOut,
              max_login_feature: this.dataMaxDailyLoginFeature,
            }
          }).then(response => {
          if (response) {
            this.successNotificationUpdate()
            this.$emit('closeSidebar')
          }
        }).catch(error => {
          console.log(error)
        })


    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    setMaxDailyLogins () {
this.dataMaxDailyLogins=1;
    },
    successNotificationUpdate() {
      this.$vs.notify({
        title: 'Setting',
        text: 'Saved successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    successNotification() {
      this.$vs.notify({
        title: 'Reset Daily Logins',
        text: 'Users` number of logins have been reset for the day.',
        color: 'success',
        position: 'top-right'
      })
    },
    NotAlloweddNotification() {
      this.$vs.notify({
        title: 'Not Allowed',
        text: 'Only greater than 0 value allowed',
        color: 'danger',
        position: 'top-right'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
